module.exports = __webpack_public_path__ + "media/images/steps/step_2-b4958eaf2bf117441a230b3e3be5d5c0.svg";